import ColoredBackground from './ColoredBackground';
export default ColoredBackground;